import { render, staticRenderFns } from "./recomeThings.vue?vue&type=template&id=429b7c20&scoped=true&"
import script from "./recomeThings.vue?vue&type=script&lang=js&"
export * from "./recomeThings.vue?vue&type=script&lang=js&"
import style0 from "./recomeThings.vue?vue&type=style&index=0&id=429b7c20&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "429b7c20",
  null
  
)

export default component.exports